module.exports = __webpack_public_path__ + "static/media/logo_rojo.6c9a4c06.png";